module.exports = __webpack_public_path__ + "static/media/img_20.3fb6a2d9.png";